import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedNew202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_new_202604",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 48685,
  clicks: 1001,
  adsSpendDollars: 3307,
  budgetDollars: 4000,
  salesDollars: 23946,
  bestEstimateRoas: 7.24,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.83,
  newCustomersAcquired: 78,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
